import React,{ createContext,useState} from "react";

export const RemoveChatContext = createContext()

export const RemoveChatProvider = ({children})=>{
    const [userid,setUserid] = useState([]);
    
    return (<RemoveChatContext.Provider value={{userid , setUserid}}>{children}</RemoveChatContext.Provider>)
}